const ComponentGroupsModal = require("../../src/client-ts/containers/Estimation/ComponentGroups/ComponentGroupEditModal");

exports.newComponentGroupEditModal =
  ComponentGroupsModal.ComponentGroupEditModal;
